import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import Vuelidate from "vuelidate";
import Paginate from "vuejs-paginate";
import Snotify from "vue-snotify";
import { store } from "./store/store";

import Common from "@/mixins/Common.js";
import Auth from "@/mixins/Auth.js";
import Sidemenu from "@/mixins/Sidemenu.js";
import VueAnalytics from 'vue-analytics'

window.$ = window.jQuery = require("jquery");

Vue.use(Vuelidate);
Vue.use(Snotify);
Vue.use(VueAnalytics, {
  id: 'UA-140472972-1',
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
})
Vue.component("paginate", Paginate);
Vue.mixin(Common);
Vue.mixin(Auth);
Vue.mixin(Sidemenu);

require("./assets/js/manual.js");

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.isAuth)) {
    if (Auth.methods.isAuth()) {
      next();
    } else {
      router.push({ name: "SignIn" });
    }
  } else if (to.matched.some(record => record.meta.noAuth)) {
    if (!Auth.methods.isAuth()) {
      next();
    } else {
      router.push("/");
    }
  } else {
    next();
  }
});

import initializeToken from "./assets/js/token.js";
initializeToken(store).then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
});